import { AlphabetSelectionActionTypes, AlphabetSelectionActions } from '../actions/alphabet-selection.action';

export const AlphabetSelectionKey = 'alphabetSelection';

export interface AlphabetSelectionState {
    selectedAlphas: { [key: string]: string };
}

export const initialState = {
    selectedAlphas: {} as { [key: string]: string }
};


export function alphabetSelectionReducer(state = initialState, action: AlphabetSelectionActions): AlphabetSelectionState  {
  switch (action.type) {
      case AlphabetSelectionActionTypes.SelectedAlphabar:
          return {
              ...state,
              selectedAlphas: {
                  ...state.selectedAlphas,
                  [action.identifier]: action.selectedAlpha
              }
          };
      default:
          return state;
    }
}

export function reducer(state: AlphabetSelectionState, action: AlphabetSelectionActions): AlphabetSelectionState {
  return alphabetSelectionReducer(state, action);
}